/*------------------------------------*\
    MODULES
\*------------------------------------*/
import $ from "jquery";

/*------------------------------------*\
    SLIDER SWIPER
\*------------------------------------*/
class SliderSwiper {
    constructor(passedElement) {
        let self = this;

        self.elem = passedElement;
    }

    init() {
        let self = this;

        console.log('slider-swiper');
    }
}

export default SliderSwiper;
